/* @flow */

import { SearchResultLayout } from "../components/articles/shared/article-badges/SearchResultLayout";
import SEARCH_RESULT_LAYOUT from "../components/articles/shared/article-badges/SearchResultLayout";

export function getImageBreakPointConfigs(searchResultLayout: SearchResultLayout) {
    if (searchResultLayout === SEARCH_RESULT_LAYOUT.LIST) {
        return [{ upperBreakpoint: 768, imageWidth: 144, imageHeight: 144 }];
    }
    return [];
}

export function getDefaultImageWidth(searchResultLayout: SearchResultLayout) {
    if (searchResultLayout === SEARCH_RESULT_LAYOUT.LIST) {
        return 90;
    }
    return 144;
}

export function getDefaultImageHeight(searchResultLayout: SearchResultLayout) {
    if (searchResultLayout === SEARCH_RESULT_LAYOUT.LIST) {
        return 90;
    }
    return 144;
}
